import { gql } from '@apollo/client';
import { useApolloContext } from 'contexts';
import { useDeskAllowsIssueReportsQuery } from 'generated/graphql';

export const DeskAllowsIssueReports = gql`
  query DeskAllowsIssueReports($deskId: ID!) {
    deskAllowsIssueReports(deskId: $deskId) {
      allowed
    }
  }
`;

export const useDeskAllowsIssueReports = (
  deskId: string | null | undefined
) => {
  const { tenantId } = useApolloContext();

  const { loading, data } = useDeskAllowsIssueReportsQuery({
    skip: !tenantId || !deskId,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      deskId: deskId || '',
    },
  });

  return {
    loading,
    allowed: data?.deskAllowsIssueReports.allowed ?? false,
  };
};
